import { Button, CircularProgress, Menu, MenuItem } from '@mui/material';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import useSearch from 'hooks/useSearch';
import useSetQuery from 'hooks/useSetQuery';
import { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import DashboardAddModal from './DashboardAddModal';
import { useLocation } from 'react-router-dom';

const DashboardMenu = ({ addAllowed = false, openSettings }) => {
  const query = useSearch();
  const { pathname } = useLocation();
  const setQuery = useSetQuery();
  const axiosPrivate = useAxiosPrivate();
  const { t } = useTranslation();
  const [hasError, setHasError] = useState(false);
  const [open, setOpen] = useState(false);
  const [openAddModal, setOpenAddModal] = useState(false);

  let anchorEl = document.getElementById('dashboard-menu-btn');

  const { data, isLoading, isFetching, refetch } = useQuery({
    queryKey: 'admin/widgets/dashboards',
    queryFn: async function () {
      const response = await axiosPrivate.get('/admin/widgets/dashboards');
      return response.data.data;
    },
    enabled: !hasError,
    onSuccess: (data) => {
      if (data && data.length > 0) {
        if (!query.get('dashboard') && pathname === '/admin/dashboard') {
          setQuery('dashboard', data?.[0]?.id);
          setQuery('dashboard_name', data?.[0]?.name);
        }
      }
    },
    onError: (error) => {
      setHasError(true);
    },
    retry: false,
  });

  useEffect(() => {
    if (!query.get('dashboard') && pathname === '/admin/dashboard') {
      setQuery('dashboard', data?.[0]?.id);
      setQuery('dashboard_name', data?.[0]?.name);
    }
    return () => {};
  }, [data, query.get('dashboard'), pathname]);

  const handleChangeCRMBlock = (item) => {
    setQuery('dashboard', item?.id);
    setQuery('dashboard_name', item?.name);
    menuToggle();
  };
  const menuToggle = () => {
    setOpen((prev) => !prev);
  };

  return isLoading && isFetching ? (
    <CircularProgress size={25} color='inherit' />
  ) : (
    <div className='crm-blocks-wrapper whitespace-nowrap'>
      <Button
        id='dashboard-menu-btn'
        className='dashboard-menu-btn'
        onClick={menuToggle}
        variant='select-menu'
      >
        {query.get('dashboard_name') || ''}
        <i
          className={`bi bi-chevron-down btn-icon ${
            open ? 'rotate-180' : 'rotate-0'
          }`}
        />
      </Button>
      <Menu
        open={open}
        anchorEl={anchorEl}
        disableScrollLock={true}
        onClose={menuToggle}
        className='crm-blocks-menu'
      >
        {data && data.length > 0 ? (
          data.map((item, index) => (
            <MenuItem
              key={`crm-block-${index + 1}`}
              onClick={() => handleChangeCRMBlock(item)}
              className={query.get('dashboard') == item?.id ? 'is-active' : ''}
            >
              {item.name}
            </MenuItem>
          ))
        ) : (
          <div>
            <span className='no-data-found-wrapper select-box px-4'>
              <i className='bi bi-exclamation-octagon text-lg mr-1' />{' '}
              {t('common.global.noDataFound')}
            </span>
          </div>
        )}
      </Menu>
      {addAllowed && !openSettings && (
        <Button
          type='button'
          variant='actionLarge'
          color='primary'
          className='!ml-2'
          onClick={() => setOpenAddModal(true)}
        >
          <i className='bi bi-plus' />
        </Button>
      )}
      {openAddModal && addAllowed && (
        <DashboardAddModal
          open={openAddModal}
          setOpen={setOpenAddModal}
          refetchFn={refetch}
          lastOrder={data ? data.length : 0}
        />
      )}
    </div>
  );
};
export default memo(DashboardMenu);
